exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._31Xvd{position:fixed;right:80px;bottom:30px;-webkit-box-sizing:border-box;box-sizing:border-box;width:448px;padding:30px 30px 0;background:#fff;-webkit-box-shadow:0 10px 20px 0 rgba(0,0,0,.1);box-shadow:0 10px 20px 0 rgba(0,0,0,.1);border-radius:6px;border:1px solid #dedede;z-index:100}._35aJD{padding-bottom:16px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500}._2CaaN{padding-bottom:6px;font-family:PingFangSC-Regular;font-weight:400;color:#36404a;font-size:16px}.vIznV{color:#3098ff}._2LGwA{padding:24px 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3HPR_{width:176px;border-radius:8px;border:1px solid #ebebeb;line-height:50px;font-size:20px;text-align:center;font-family:PingFangSC-Medium;font-weight:500}.N1-aW{display:block;color:#828b93}._2iS9D{display:block;background:#fb4a3e;color:#fff}", ""]);

// exports
exports.locals = {
	"privacyContainer": "_31Xvd",
	"listTitle": "_35aJD",
	"list": "_2CaaN",
	"privacyPolicy": "vIznV",
	"oprate": "_2LGwA",
	"btn": "_3HPR_",
	"disagree": "N1-aW",
	"agree": "_2iS9D"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/p_home/PrivacyPolicy/index.css
// module id = 1240
// module chunks = 1